import {
  AUTH_KEY_BY_INSTALLABLE_MODULE,
  INSTALLABLE_MODULE_KEYS,
  type InstallableModuleKey,
} from "@playbookai/types";

/** Auth catalogue key → installable key; `null` for a capability or unknown. */
export function installableKeyForAuthKey(
  authKey: string,
): InstallableModuleKey | null {
  return (
    INSTALLABLE_MODULE_KEYS.find(
      (key) => AUTH_KEY_BY_INSTALLABLE_MODULE[key] === authKey,
    ) ?? null
  );
}
